import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AdminsPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddAdminModalOpened: boolean;
}

export const initialState: AdminsPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddAdminModalOpened: false,
};

const adminsPageSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    setAdminsPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearAdminsPageSearchValue(state) {
      state.searchValue = '';
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddAdminModalOpened = action.payload;
    },
  },
});

export const {
  setAdminsPageSearchValue,
  clearAdminsPageSearchValue,
  changeModalVisibility,
} = adminsPageSlice.actions;
export default adminsPageSlice.reducer;
